import RAPIER from "@dimforge/rapier3d-compat";

// Fracture-related plumbing — the velocity threshold, single-shard
// body factory, and the lone constant the detector needs. The actual
// fracture lifecycle (queue, performFracture, unfracture, registry
// access) lives in physics.ts because it's tightly coupled to the
// cup registry; this module just exports the standalone pieces.

// Linear-velocity magnitude required at collision-start to shatter a
// cup. A cup free-falling from the top shelf (y≈2.5 → 0) reaches
// ~7 m/s, so the threshold is set just above that: gentle drops and
// shelf-edge bumps won't break, only deliberate throws.
export const FRACTURE_VELOCITY = 8;

/**
 * Single-shard body factory used by both the fracture engine
 * (via FractureInput.addShard) and the public PhysicsHandle.createShard.
 * Keeps every Rapier body-creation call for shards in one place.
 */
export function createShardBody(
  world: RAPIER.World,
  worldCenter: { x: number; y: number; z: number },
  rotation: { x: number; y: number; z: number; w: number },
  hullPoints: Float32Array,
): RAPIER.RigidBody | null {
  const colDesc = RAPIER.ColliderDesc.convexHull(hullPoints);
  if (!colDesc) return null;
  colDesc.setMass(0.05).setFriction(0.5).setRestitution(0.12);
  const body = world.createRigidBody(
    RAPIER.RigidBodyDesc.dynamic()
      .setTranslation(worldCenter.x, worldCenter.y, worldCenter.z)
      .setRotation(rotation)
      .setLinearDamping(0.15)
      .setAngularDamping(0.3)
      .setCanSleep(true)
      .setCcdEnabled(true),
  );
  world.createCollider(colDesc, body);
  return body;
}
